<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QOSmJ6/tc-custom/9781429967655.jpg?1722626092621" alt="This image is the cover for the book Steal Across the Sky"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Steal Across the Sky
      </h1>
      <p class="bookDescription body article font2">
        <b>Aliens try to atone for past wrongs to humanity and take twenty-one humans on a revelatory journey in this science fiction novel by a Nebula Award–winning author.</b><br/><br/>The aliens appeared one day, built a base on the moon, and put an ad on the internet:<br/><br/>“We are an alien race you may call the Atoners. Ten thousand years ago we wronged humanity profoundly. We cannot undo what has been done, but we wish humanity to understand it. Therefore, we request twenty-one volunteers to visit seven planets to Witness for us. We will convey each volunteer there and back in complete safety. Volunteers must speak English. Send requests for electronic applications to witness@Atoners.com.”<br/><br/>At first, everyone thought it was a joke. But it wasn’t.<br/><br/>This is the story of three of those volunteers, and what they found on Kular A and Kular B . . . <br/><br/><b>Praise for <i>Steal Across the Sky</i></b><br/><br/>“Kress skillfully explores the consequences of her ideas. . . . Arrestingly ambiguous and persuasively set forth—in the best science-fiction tradition, guaranteed provocative no matter what your personal opinions.” —<i>Kirkus Reviews </i>(starred review)
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nancy Kress
      </h2>
      
      <p class="authorDescription body article"><P><B>Nancy Kress</B> is the author of twenty-two books: fourteen novels of science fiction or fantasy. She has won three Nebulas, a Hugo, and the John W. Campbell Memorial Award.  Kress is the monthly "Fiction" columnist for <I>Writer's Digest Magazine</I>. She teaches regularly at Clarion.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?28e46f61